import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const Image = ({
  image,
  alt,
  className,
  loading = 'lazy',
  role,
  objectFit,
  'aria-hidden': ariaHidden,
  style,
  imgStyle,
  itemProp
}) => {
  const gatsbyImageData = getImage(image);
  const imageUrl = image?.file?.url;
  const altText = alt || image?.description || '';

  if (gatsbyImageData === undefined && imageUrl === undefined) {
    return null;
  }

  // SVG's don't work with GatsbyImage so we need to render them differently
  if (gatsbyImageData === undefined) {
    const width = image.file?.details?.image?.width;
    const height = image.file?.details?.image?.height;

    return (
      <img
        src={imageUrl}
        width={width}
        height={height}
        alt={altText}
        className={className}
        loading={loading}
        role={role}
        aria-hidden={ariaHidden}
        itemProp={itemProp}
      />
    );
  }

  return (
    <GatsbyImage
      image={getImage(image)}
      alt={altText}
      className={className}
      loading={loading}
      role={role}
      objectFit={objectFit}
      style={style}
      imgStyle={imgStyle}
      aria-hidden={ariaHidden}
      itemProp={itemProp}
    />
  );
};

Image.propTypes = {
  image: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    gatsbyImageData: PropTypes.object,
    file: PropTypes.shape({
      contentType: PropTypes.string,
      url: PropTypes.string,
      details: PropTypes.shape({
        image: PropTypes.shape({
          width: PropTypes.number,
          height: PropTypes.number,
        })
      })
    }),
    description: PropTypes.string,
  }),
  alt: PropTypes.string,
  className: PropTypes.string,
  role: PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  itemProp: PropTypes.string
};

export const query = graphql`
  fragment ImageAssetFragment on ContentfulAsset {
    description
    file {
      url
      details {
        image {
          width
          height
        }
      }
    }
  }
`;

export default Image;
